import type { GroupBy, TaskListMode } from "../../domain/app-types.ts";
import type { Todo } from "../../domain/entities.ts";
import { capitalize, escapeHtml } from "../../ui/text.ts";
import type { BoardInactiveDays } from "./board-inactivity.ts";
import { activeTags } from "./selectors.ts";

export interface ListIcons {
  left: string;
  right: string;
  check?: string;
}

export function taskPagerView(page: number, pages: number, count: number, icons: ListIcons): string {
  return `<nav class="task-pagination" aria-label="Task pages"><button class="button button--soft" data-action="task-page" data-page="${page - 1}" ${page === 1 ? "disabled" : ""}>${icons.left} Previous</button><span>Page ${page} of ${pages} · ${count} tasks</span><button class="button button--soft" data-action="task-page" data-page="${page + 1}" ${page === pages ? "disabled" : ""}>Next ${icons.right}</button></nav>`;
}

export function taskGroupLabel(todo: Todo, grouping: GroupBy, memberEmail: (id: string) => string, categoryName: (id: string) => string): string {
  if (grouping === "assignee") return todo.assignedTo?.[0] ? memberEmail(todo.assignedTo[0]) : "Unassigned";
  if (grouping === "priority") return todo.priority === "none" ? "No priority" : capitalize(todo.priority);
  if (grouping === "tag") return activeTags(todo)[0] ? `#${activeTags(todo)[0]}` : "No tag";
  if (grouping === "status") return todo.completed ? "Completed" : "Open";
  if (grouping === "subcategory") return todo.categoryId ? categoryName(todo.categoryId) : "No collection";
  return "Tasks";
}

export function taskListModeToggleView(mode: TaskListMode): string {
  return `<div class="task-list-modes segmented-control" role="group" aria-label="Task list display"><button data-action="task-list-mode" data-mode="simple" aria-pressed="${mode === "simple"}">Simple</button><button data-action="task-list-mode" data-mode="detailed" aria-pressed="${mode === "detailed"}">Detailed</button></div>`;
}

export function boardCardModeToggleView(mode: "simple" | "detailed"): string {
  return `<div class="task-list-modes segmented-control" role="group" aria-label="Board card display"><button data-action="board-card-mode" data-mode="simple" aria-pressed="${mode === "simple"}">Simple</button><button data-action="board-card-mode" data-mode="detailed" aria-pressed="${mode === "detailed"}">Detailed</button></div>`;
}

export function boardInactiveFilterView(days: BoardInactiveDays): string {
  return `<label class="board-inactive-filter ${days ? "is-active" : ""}"><span>Inactive</span><select data-board-inactive aria-label="Show tasks inactive for"><option value="0">Any time</option>${([7, 14, 30, 90] as BoardInactiveDays[]).map(option => `<option value="${option}" ${days === option ? "selected" : ""}>${option}+ days</option>`).join("")}</select></label>`;
}

export function bulkSelectorView(todo: Todo, editable: boolean, selected: boolean, checkIcon: string): string {
  return `<label class="bulk-selector"><input type="checkbox" data-select-task="${todo.id}" aria-label="Select ${escapeHtml(todo.title || "task")}" ${selected ? "checked" : ""} ${editable ? "" : "disabled"}><span>${checkIcon}</span></label>`;
}
